module.exports = __webpack_public_path__ + "static/img/detailleftback.96ed7dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/detailleftback.png
// module id = zKcT
// module chunks = 1